const chatEvent = {
  a1: ['首页', '首屏1免费试用'],
  c1: ['首页', '外呼插件'],
  c2: ['首页', '音视频通讯'],
  c3: ['首页', '在线表单'],
  c4: ['首页', '微信客服'],
  c5: ['首页', '15天免费试用'],
  c6: ['首页', '多客助手'],
  d1: ['详情', '20元使用在线客服'],
  d2: ['详情', '基础产品'],
  d3: ['详情', '对话功能'],
  d4: ['详情', '客户管理'],
  d5: ['详情', '高级应用'],
  d6: ['详情', '补充功能'],
  d7: ['详情', '入门套餐'],
  d8: ['详情', '进阶套餐'],
  d9: ['详情', '全功能套餐'],
  d10: ['详情', '咨询套餐'],
  n1: ['导航', '导航']
};

const handleGa = (action, data = []) => {
  window.gtag('event', action, {
    event_category: data[0],
    event_label: data[1],
    value: data[2]
  });
};

export const getButtonData = name => {
  return chatEvent[name];
};

export default handleGa;
